import React from 'react'

import { Route } from 'react-router-dom'
import { RouteAuthorizer, ActionsAuthorizer } from '../../../Authorizer'
import { CompanyPaymentEdit } from '../../../../components/Management'
import CompanyView from '../../../../components/OrganizationView/CompanyView'
import CompanyEdit from '../../../../components/OrganizationView/CompanyEdit'
import ManagementActions from '../ManagementActions'
import CompanyManagement from '../../../../components/OrganizationView'

const AuthorizedCompanyManagement = ActionsAuthorizer(ManagementActions)(CompanyManagement)
const AuthorizedCompanyView = RouteAuthorizer([])(ActionsAuthorizer(ManagementActions)(CompanyView))
const AuthorizedCompanyEdit = RouteAuthorizer(['brandManager', 'delegationManager', 'operator', 'comunityManager'])(
  ActionsAuthorizer(ManagementActions)(CompanyEdit)
)
const AuthorizedCompanyPaymentEdit = RouteAuthorizer(['brandManager', 'delegationManager', 'operator', 'comunityManager'])(
  ActionsAuthorizer(ManagementActions)(CompanyPaymentEdit)
)

// eslint-disable-next-line react/display-name
export default ({ match }) => (
  <div>
    <Route exact path={`${match.path}/:id`} component={AuthorizedCompanyView} />
    <Route exact path={`${match.path}/:id/edit`} component={AuthorizedCompanyEdit} />
    <Route exact path={`${match.path}/:id/payment/edit`} component={AuthorizedCompanyPaymentEdit} />

    <Route path={match.path} component={AuthorizedCompanyManagement} />
  </div>
)
